/**
 * =============================================================================
 * ASISTENTE DE REVI — CANAL PROPIO
 * =============================================================================
 * Sustituye a `createThreadUseCase` / `postQuestionUseCase`, que apuntaban al
 * chat de K12 y necesitaban el ObjectId de un asistente escrito a mano en el
 * frontend.
 *
 * Aqui no hay ningun id: el servidor construye la personalidad a partir del rol
 * que lleva el token y del catalogo real de la plataforma. Un asistente menos
 * que mantener a mano, y uno que no se puede quedar desfasado.
 *
 * El mensaje va en el CUERPO, no en la query. El canal de K12 lo manda en
 * `?data=`, y un texto en la URL acaba en logs de servidor, en el historial del
 * navegador y en caches de proxy.
 * =============================================================================
 */

import { ENV } from "../../Utils";
import { cabecerasApi } from "./cabeceras";

export class ReviAssistantApi {
  constructor() {
    this.base = `${ENV.BASE_API}/revi/assistant`;
  }

  /** Abre una conversacion. La personalidad la decide el servidor por el rol. */
  async crearHilo(token) {
    return this._fetch(`${this.base}/thread`, {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
    });
  }

  async enviar(token, threadId, message) {
    return this._fetch(`${this.base}/message`, {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify({ threadId, message }),
    });
  }

  async _fetch(url, params) {
    const response = await fetch(url, params);
    let json = null;
    try {
      json = await response.json();
    } catch (e) {
      json = null;
    }
    if (response.ok) return json;

    const err = new Error(json?.message || `HTTP ${response.status}`);
    err.status = response.status;
    err.body = json;
    throw err;
  }
}
